// extracted by mini-css-extract-plugin
module.exports = {"rangeContainer":"y0wpOmdNXeVTLiMplAUc","saveButton":"VFBctcz8q5sO3bW0nz3b"};